import { render, staticRenderFns } from "./BuscarAlumno.vue?vue&type=template&id=24a9b4f5&"
import script from "./BuscarAlumno.vue?vue&type=script&lang=js&"
export * from "./BuscarAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports